'use client';

import { useState } from 'react';
import type { SB_CategoryGalleryBlockProps } from '../types.generated';
import { type FilterType } from './shared';
import { CategoryGalleryBlock } from './CategoryGalleryBlock';
import { Button, ButtonLink } from '~/components/primitives';
import { useI18n } from '~/features/i18n';
import { I18N_CONF } from '@funkey/locales/config';

export const CategorySectionClient: React.FC<{
    remainingBloks: {
        blok: SB_CategoryGalleryBlockProps;
        config: { filterType: FilterType; filterId: number };
    }[];
    initialCategoriesCount: number;
}> = ({ remainingBloks: remainingBlocks, initialCategoriesCount }) => {
    const i18n = useI18n();
    const [loadedBatches, setLoadedBatches] = useState(0);
    const totalLoadedBlocks = loadedBatches * initialCategoriesCount;
    const hasMoreBlocks = totalLoadedBlocks < remainingBlocks.length;

    if (remainingBlocks.length === 0) return null;

    return (
        <>
            {remainingBlocks.slice(0, totalLoadedBlocks).map(({ blok: block, config }) => {
                if (!config?.filterType) return null;

                return (
                    <CategoryGalleryBlock
                        key={block._uid}
                        blok={block}
                        config={{
                            ...config,
                            refetchOnMount: true,
                        }}
                    />
                );
            })}

            <div className="container my-5 text-center md:my-8">
                {hasMoreBlocks ? (
                    <Button onClick={() => setLoadedBatches(prev => prev + 1)} variant="tertiary">
                        {i18n._('Load more')}
                    </Button>
                ) : (
                    <ButtonLink
                        href={I18N_CONF.getTranslatedUrl('teambuildings', {
                            locale: i18n.locale,
                        })}
                        variant="tertiary"
                    >
                        {i18n._('website.home.cta.all_categories')}
                    </ButtonLink>
                )}
            </div>
        </>
    );
};
